// @ts-nocheck

// App
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { useYieldCallback } from '@zillow/yield-callback';

// Components
import BedButtons from 'app/shared/modules/MobileSRP/Header/FilterModules/BedBathComboFilter/BedButtons';
import Checkbox from 'app/shared/modules/MobileSRP/__BaseComponents__/Checkbox';

// Hooks
import { useFilterChange } from 'app/shared/modules/filter/FilterBar/hooks';

// Misc / utils
import {
  GeneralApplyFilterButton,
  GeneralFilterHeader,
  GeneralFilterLabel,
} from 'app/shared/modules/filter/FilterBar/styles';

const FALSY_STATE = {
  anyOrStudio: false,
  oneOrMore: false,
  twoOrMore: false,
  threeOrMore: false,
  fourOrMore: false,
};
const InfoCardBedSelector = () => {
  // Redux
  const bedState = useSelector((state) => state.filter.bedrooms);

  // React state
  const [filterState, setFilterState] = useState(bedState);

  // Hooks
  const { filterChange } = useFilterChange();

  const shouldShowApplyButton =
    (filterState.isExact === false && filterState.anyOrStudio !== true) || filterState.isExact === true;

  const yieldTrackFilterChange = useYieldCallback(() => {
    filterChange({ bedrooms: filterState });
  });
  const handleFilterApply = () => {
    yieldTrackFilterChange();
  };
  const handleBedroomOptionClick = (e) => {
    const option = e.currentTarget.getAttribute('data-option-value');

    // Guard against null/undefined option
    if (!option) return;

    const change = Object.assign({}, FALSY_STATE, { isExact: filterState.isExact });
    change[option] = !filterState[option];

    setFilterState({
      ...change,
    });
  };
  const handleBedCheckboxClick = () => {
    setFilterState({
      ...filterState,
      isExact: !filterState.isExact,
    });
  };

  return (
    <>
      <GeneralFilterHeader>
        <GeneralFilterLabel id="bedroom-info-card-label">Bedrooms</GeneralFilterLabel>
        {shouldShowApplyButton && (
          <GeneralApplyFilterButton onClick={handleFilterApply} aria-label={'Apply number of bedrooms filter'}>
            Apply
          </GeneralApplyFilterButton>
        )}
      </GeneralFilterHeader>
      <BedButtons handleClick={handleBedroomOptionClick} state={filterState} />
      <Checkbox
        onChange={handleBedCheckboxClick}
        isChecked={filterState.isExact}
        ariaLabel={'Use exact number of bedrooms'}
      >
        Use exact number of bedrooms
      </Checkbox>
    </>
  );
};

export default InfoCardBedSelector;
